module.exports = __webpack_public_path__ + "rili.7f17aa0d.jpg";